module.exports = __webpack_public_path__ + "img/quote.a58145d.svg";